export default __webpack_public_path__ + "static/media/document-new.6300cb23.svg";